import { NumberBadge, NumberBadgeItems } from '../../../components/common/NumberBadge';
import './sideList.css';
import { useTranslation } from 'react-i18next';

export default function ProfileSideList({ allProfilesCategories, selectedCategory, setSelectedCategory, setCurrentPage, itemCount, handleChange }) {
    const { t, i18n } = useTranslation();

    return (
        <>
            <select className="form-select form-select-sm d-md-none" value={selectedCategory}
                onChange={handleChange}>
                <option value="">{t("Show All")}</option>
                {allProfilesCategories.map((category, index) => (
                    <option key={index} value={category.en} >
                        {i18n.language === "ar" ? category.ar : category.en}
                    </option>
                ))}
            </select>

            <ul className="d-none d-md-block list-group col-3 col-md-2 pt-2 sticky-top h-100">
                <li className={`list-group-item list-group-item-action ps-2 bg-light-gray`}
                    onClick={() => setSelectedCategory(null)}>
                    {t("Show All")}
                    <NumberBadge
                        selectedCategory={selectedCategory}
                        itemCount={itemCount}
                    />
                </li>
                {allProfilesCategories.map((category, index) => (
                    <li key={index} className={`list-group-item list-group-item-action ps-2 ${selectedCategory === category.en ? 'active' : ''}`}
                        onClick={() => {
                            setSelectedCategory(category.en);
                            setCurrentPage(1);
                        }}>
                        {i18n.language === "ar" ? category.ar : category.en}
                        <NumberBadgeItems
                            selectedCategory={selectedCategory}
                            itemCount={itemCount}
                            category={category.en}
                        />
                    </li>
                ))}
            </ul>
        </>
    )
}